(() => {
  const initializedAttribute = 'data-christmas-countdown-initialized';

  function initializeCountdown(countdown) {
    if (countdown.hasAttribute(initializedAttribute)) return;

    const target = Date.parse(countdown.dataset.target || '');
    if (!Number.isFinite(target)) {
      countdown.hidden = true;
      return;
    }

    countdown.setAttribute(initializedAttribute, 'true');

    const fields = {
      days: countdown.querySelector('[data-countdown-days]'),
      hours: countdown.querySelector('[data-countdown-hours]'),
      minutes: countdown.querySelector('[data-countdown-minutes]'),
      seconds: countdown.querySelector('[data-countdown-seconds]'),
    };

    let intervalId;

    function update() {
      const remaining = Math.max(0, target - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);

      fields.days.textContent = String(Math.floor(totalSeconds / 86400)).padStart(2, '0');
      fields.hours.textContent = String(Math.floor((totalSeconds % 86400) / 3600)).padStart(2, '0');
      fields.minutes.textContent = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
      fields.seconds.textContent = String(totalSeconds % 60).padStart(2, '0');

      if (remaining === 0) window.clearInterval(intervalId);
    }

    update();
    intervalId = window.setInterval(update, 1000);
  }

  function initialize(root = document) {
    root.querySelectorAll('[data-christmas-countdown]').forEach(initializeCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
